//#region src/index.ts
const HOME_URL = "/";
const LOGIN_URL = "/login";
const REGISTER_URL = "/register";
const MY_PERSONAL_ACCOUNT_URL = "/my-personal-account";
const SHARED_MEALS_URL = "/shared-meals";
const SHARED_MEALS_HISTORY_URL = "/shared-meals/history";
const VOLUNTEERS_URL = "/volunteers";
const AVAILABILITIES_URL = "/availabilities";
const PLANNING_URL = "/planning";
const MULTI_PLANNING_URL = "/multi-planning";
const VOLUNTEER_CHARTER_URL = "/volunteer-charter";
const FA_URL = "/fa";
const FT_URL = "/ft";
const FA_TO_PUBLISH_URL = "/fa/to-publish";
const SECURITY_DASHBOARD_URL = "/fa/dashboard/security";
const FA_GEAR_DASHBOARD_URL = "/fa/dashboard/logistic";
const STATS_URL = "/stats";
const GEAR_CATALOG_URL = "/logistic/catalog";
const INVENTORY_URL = "/logistic/inventory";
const GEAR_DASHBOARD_URL = "/logistic/dashboard";
const BORROW_GEARS_URL = "/logistic/borrow";
const LOCATION_URL = "/signa/location";
const SIGNAGE_CATALOG_URL = "/signa/catalog";
const CONFIGURATION_URL = "/configuration";
const REGISTRATIONS_STAFF_URL = "/registrations/staff";
const REGISTRATIONS_VOLUNTEER_URL = "/registrations/volunteer";
const CONTRIBUTIONS_URL = "/contributions";
const SG_URL = "/sg";
const TRANSACTIONS_URL = "/transactions";
const CHARISMA_EVENTS_MANAGE_URL = "/charisma/events/manage";
const CHARISMA_EVENTS_LIST_URL = "/charisma/events/list";
const CHARISMA_PERIODS_URL = "/charisma/periods";
const ASSIGNMENT_ORGA_TASK_URL = "/assignment/orga-task";
const ASSIGNMENT_TASK_ORGA_URL = "/assignment/task-orga";
const ORGA_NEED_URL = "/orga-need";
const TIMELINE_URL = "/timeline";
const NEED_HELP_URL = "/need-help";
const pagesURL = [
	"/",
	MY_PERSONAL_ACCOUNT_URL,
	SHARED_MEALS_URL,
	SHARED_MEALS_HISTORY_URL,
	VOLUNTEERS_URL,
	AVAILABILITIES_URL,
	PLANNING_URL,
	MULTI_PLANNING_URL,
	"/fa",
	"/ft",
	FA_GEAR_DASHBOARD_URL,
	FA_TO_PUBLISH_URL,
	SECURITY_DASHBOARD_URL,
	STATS_URL,
	GEAR_CATALOG_URL,
	INVENTORY_URL,
	GEAR_DASHBOARD_URL,
	BORROW_GEARS_URL,
	LOCATION_URL,
	SIGNAGE_CATALOG_URL,
	CONFIGURATION_URL,
	REGISTRATIONS_STAFF_URL,
	REGISTRATIONS_VOLUNTEER_URL,
	CONTRIBUTIONS_URL,
	"/sg",
	TRANSACTIONS_URL,
	CHARISMA_EVENTS_MANAGE_URL,
	CHARISMA_EVENTS_LIST_URL,
	CHARISMA_PERIODS_URL,
	ASSIGNMENT_ORGA_TASK_URL,
	ASSIGNMENT_TASK_ORGA_URL,
	ORGA_NEED_URL,
	TIMELINE_URL,
	NEED_HELP_URL,
	VOLUNTEER_CHARTER_URL
];
function isPageURL(url) {
	return pagesURL.some((page) => page === url);
}
//#endregion
export { ASSIGNMENT_ORGA_TASK_URL, ASSIGNMENT_TASK_ORGA_URL, AVAILABILITIES_URL, BORROW_GEARS_URL, CHARISMA_EVENTS_LIST_URL, CHARISMA_EVENTS_MANAGE_URL, CHARISMA_PERIODS_URL, CONFIGURATION_URL, CONTRIBUTIONS_URL, FA_GEAR_DASHBOARD_URL, FA_TO_PUBLISH_URL, FA_URL, FT_URL, GEAR_CATALOG_URL, GEAR_DASHBOARD_URL, HOME_URL, INVENTORY_URL, LOCATION_URL, LOGIN_URL, MULTI_PLANNING_URL, MY_PERSONAL_ACCOUNT_URL, NEED_HELP_URL, ORGA_NEED_URL, PLANNING_URL, REGISTER_URL, REGISTRATIONS_STAFF_URL, REGISTRATIONS_VOLUNTEER_URL, SECURITY_DASHBOARD_URL, SG_URL, SHARED_MEALS_HISTORY_URL, SHARED_MEALS_URL, SIGNAGE_CATALOG_URL, STATS_URL, TIMELINE_URL, TRANSACTIONS_URL, VOLUNTEERS_URL, VOLUNTEER_CHARTER_URL, isPageURL, pagesURL };

//# sourceMappingURL=index.mjs.map